module.exports = __webpack_public_path__ + "img/feldberg-7338.f4ee918a.jpeg";